/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import Imagen from '../Imagen/Imagen';
import Botonera from '../Botonera/Botonera';
import useLoadImages from '../../hooks/useLoadImages';
import { generaListadoImagenes as generaListadoHorario } from '../../utils/generaListadoImagenes';

import moment from 'moment';

import { Box } from '@mui/material';

import CircularProgress from '@mui/material/CircularProgress';
import CustomSlider from '../CustomSlider/CustomSlider';
import { imagenAnerior, imagenSiguiente, pause, reproducir, stop } from './controls';



//  "homepage": "https://www.inumet.gub.uy/reportes/pages/visualizador_indice_uv/",
const TITLE = "Visualizador Índice UV - INUMET";
const DATE_FORMAT_TO_DISPLAY = "DD/MM/YYYY HH:mm";
const IMAGE_BASE_NAME_FORMAT = "YYYYDDDD_HHmm";
const IMAGE_BASE_PATH = "https://www.inumet.gub.uy/reportes/indice_uv/";
const INTERVAL_IMAGES = [10, "minutes"];
const MAX_DATE_INTERVAL = [6, 'hours'];
const DESCRIPTION = "<p>El Índice Ultravioleta (Índice UV) es un estandar internacional para indicar el riesgo de exposición a la radiación ultravioleta incidente en la superficie terrestre.</p> <p>En este visualizador se presentan dos paneles con estimaciones del Índice UV a través de imagenes satelitales.</p><p> El panel izquierdo presenta el Índice UV estimado, mientras que el panel derecho presenta el Índice UV estimado en condiciones de cielo despejado, es decir sin tener en cuenta la nubosidad presente.</p> <p> De esta forma el Índice UV (Con cielo despejado) muestra el peor escenario posible de exposición a la radiación ultravioleta de origen solar.</p>";
const MIN_DATE = moment().subtract(10, "minutes");



const PlayerUv = () => {
    const listadoHorario = useMemo(() => generaListadoHorario({ MIN_DATE, MAX_DATE_INTERVAL, IMAGE_BASE_NAME_FORMAT, INTERVAL_IMAGES }), [])
    const [listadoImagenes, setListadoImagenes] = useState([])
    const [fechaMuestra, setFechaMuestra] = useState(MIN_DATE.utc().format('DD/MM/YYYY HH:mm'))
    const [velocidad, setVelocidad] = useState(800)
    const [idReproduccion, setIdReproduccion] = useState(0)
    const [posicion, setPosicion] = useState(0);
    const [reproduciendo, setReproduciendo] = useState(0)




    const { images: imagenes_uv, error: error_uv, isLoading: isLoading_uv } = useLoadImages(
        {
            prefijo: 'iuv_',
            sufijo: '',
            listadoImagenes: listadoHorario,
            posicion,
            extencion: 'webp',
            IMAGE_BASE_PATH
        })
    const { images: imagenes_uvcsk, error: error_uvcsk, isLoading: isLoading_uvcsk } = useLoadImages(
        {
            prefijo: 'iuvcsk_',
            sufijo: '',
            listadoImagenes: listadoHorario,
            posicion,
            extencion: 'webp',
            IMAGE_BASE_PATH
        })




    const formatearFechaMuestra = useCallback(() => {
        if (listadoImagenes.length === 0) return
        const date = moment.utc(listadoImagenes[posicion].dateTime, IMAGE_BASE_NAME_FORMAT)
        setFechaMuestra(date.local().format(DATE_FORMAT_TO_DISPLAY))
    }, [posicion, listadoImagenes])





    const generaListadoImagenes = useCallback(() => {
        const listadoImagenes = []
        listadoHorario.forEach((fecha) => {
            if (imagenes_uv[fecha] && imagenes_uvcsk[fecha]) listadoImagenes.push({ uv: imagenes_uv[fecha], dateTime: fecha, uvcsk: imagenes_uvcsk[fecha] })
        })
        setListadoImagenes(listadoImagenes)
    }, [imagenes_uv, listadoHorario, imagenes_uvcsk])


    useEffect(() => {
        generaListadoImagenes()
    }, [isLoading_uv, generaListadoImagenes])


    useEffect(() => {
        if (reproduciendo === 1) {
            setTimeout(() => {
                imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })
            }, velocidad)
        }
        formatearFechaMuestra()
    }, [reproduciendo, posicion, idReproduccion, velocidad, formatearFechaMuestra, listadoImagenes])

    useEffect(() => {
        document.title = TITLE
    }, [])


    if (isLoading_uv || isLoading_uvcsk || listadoImagenes.length < 1) return <Box
        sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "center",
            justifyItems: "center",
        }}
    >
        <CircularProgress color="primary" />

    </Box>

    return (
        <Box
            sx={{
                maxWidth: "100vw",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Botonera
                stop={() => stop({ idReproduccion, setReproduciendo, setPosicion, setIdReproduccion })}
                pause={() => pause({ idReproduccion, setReproduciendo })}
                aumentarVelocidad={() => setVelocidad(velocidad - 100)}
                disminuirVelocidad={() => setVelocidad(velocidad + 100)}
                reproducir={() => reproducir({ reproduciendo, setReproduciendo })}
                imagenSiguiente={() => imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })}
                imagenAnerior={() => imagenAnerior({ listadoImagenes, posicion, setPosicion })}
                reproduciendo={reproduciendo}
            />

            <CustomSlider reproduciendo={reproduciendo} listadoImagenes={listadoImagenes} posicion={posicion} setPosicion={setPosicion} fechaMuestra={fechaMuestra} />

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "100vw",
                    maxHeight: "100vh",
                    justifyContent: "center",
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100vw",
                        gridTemplateColumns: { xs: "100vw", sm: "40vw 40vw" },

                    }}
                >
                    <Imagen src={listadoImagenes[posicion].uv} error={error_uv} />
                    <Imagen src={listadoImagenes[posicion].uvcsk} error={error_uvcsk} />
                </Box>
                <Box

                    sx={{
                        fontSize: "1rem",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        color: 'primary.dark',
                        p: 2,
                        m: 2,
                        maxWidth: { xs: "100vw", sm: "50vw" },

                    }}
                >
                    <div dangerouslySetInnerHTML={{ __html: DESCRIPTION }} />
                </Box>

            </Box>
        </Box>
    );
}

export default PlayerUv
